exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-invest-confirmed-___style__agreementContainer___2uOU6{text-align:center}.web-flows-invest-confirmed-___style__agreementContainer___2uOU6>img{border-radius:50%;width:50px;height:50px}.web-flows-invest-confirmed-___style__agreementContainer___2uOU6>h2{font-weight:400;border-bottom:none;padding-bottom:1em;padding-top:1em}.web-flows-invest-confirmed-___style__messages___2-sHd{border-bottom:1px solid #e5e3e3;border-top:1px solid #e5e3e3;padding:1em 0}.web-flows-invest-confirmed-___style__transfer___IHggj{font-size:1.1em;color:#585858;margin-bottom:.3em;margin-top:0;margin-bottom:0}.web-flows-invest-confirmed-___style__logout___1_DvC{text-align:center;margin-bottom:0;color:#95989a}", ""]);

// exports
exports.locals = {
	"agreementContainer": "web-flows-invest-confirmed-___style__agreementContainer___2uOU6",
	"messages": "web-flows-invest-confirmed-___style__messages___2-sHd",
	"transfer": "web-flows-invest-confirmed-___style__transfer___IHggj",
	"logout": "web-flows-invest-confirmed-___style__logout___1_DvC"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/invest/confirmed/style.css
// module id = 1359
// module chunks = 0